import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'hideUnavailableItem',
  initialState: false,
  reducers: {
    setHideUnavailableItem(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});
export const { setHideUnavailableItem } = slice.actions;
export default slice.reducer;
